import { render, staticRenderFns } from "./OnepersonOneCode.vue?vue&type=template&id=28409a0b&scoped=true"
import script from "./OnepersonOneCode.vue?vue&type=script&lang=js"
export * from "./OnepersonOneCode.vue?vue&type=script&lang=js"
import style0 from "./OnepersonOneCode.vue?vue&type=style&index=0&id=28409a0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28409a0b",
  null
  
)

export default component.exports